export const MAX_UPLOAD_SIZE = 20971520;